<!-- Tableau -->
<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    <button type="button" class="btn btn-primary" (click)="openCreateModal()" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
      Ajouter une étape
    </button>
  </div>
  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="stagesTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="stageNatureType.nature" (sort)="onSort($event)">Nature de l'étape</th>
            <th scope="col" class="text-center" sortable="stageNatureType.type" (sort)="onSort($event)">Type de l'étape</th>
            <th scope="col" sortable="organization" (sort)="onSort($event)">Organisme</th>
            <th scope="col" class="text-center" sortable="beginDate" (sort)="onSort($event)">Date de début</th>
            <th scope="col" class="text-center" sortable="endDate" (sort)="onSort($event)">Date de fin</th>
            <th scope="col" class="text-center" sortable="stageState" (sort)="onSort($event)">Etat de l'étape</th>
          </tr>
        </thead>
        <tbody>
          @for (stage of stages.items; track stage) {
            <tr (click)="openConsultModal(stage.id)">
              <td></td>
              <td class="text-center">{{ stageNaturesTypesById.get(stage.stageNatureTypeId).nature }}</td>
              <td class="text-center">{{ stageNaturesTypesById.get(stage.stageNatureTypeId).type }}</td>
              <td>{{ stage.organization }}</td>
              <td class="text-center">{{ stage.beginDate | date }}</td>
              <td class="text-center">{{ stage.endDate | date }}</td>
              <td class="text-center">{{ stageStates.get($stageState(stage.stageState)) }}</td>
            </tr>
          }
        </tbody>
      </table>
      @if (stages.items.length === 0) {
        <p>Le bénéficiaire n'a aucune étape.</p>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="stages.totalItems"
      [page]="stages.options.page"
      [pageSize]="stages.options.limit"
      (pageChange)="changePage($event)"
      >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="stages.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
